import React from "react"
import {Configure, InstantSearch} from "react-instantsearch"
import {liteClient as algoliasearch} from 'algoliasearch/lite'
import {initReactI18next} from "react-i18next"
import {use} from "i18next"
import CommonUtils from "@bodeboca/utils"
import ApiService from "@bodeboca/api"
import RouterService from "@bodeboca/router"
import Header from "@bodeboca/common/components/header"
import InstantSearchContent
  from "@bodeboca/algolia/apps/search/instasearch_content"
import Listener from "@bodeboca/algolia/utils/listener"


use(initReactI18next)
  .init(CommonUtils.i18NConfig())
  .then(() => {
    // I18N Loaded.
  })


const SearchApp = ({}) => {
  const algoliaClient = algoliasearch(ApiService.getAppId(), ApiService.getApiKey())
  const searchClient = {
    ...algoliaClient, search(requests) {
      if (ApiService.isContext('search')) {
        if (requests[0].params.query !== undefined && requests[0].params.query.length < 3 && requests[0].params.facetFilters === undefined) {
          CommonUtils.setIsLoading(false)
          return Promise.resolve(CommonUtils.getEmptyResults(requests))
        }
      }

      return algoliaClient.search(requests)
    },
  }



  return (<div className={"page-wrapper"} id={"algolia-wrapper"}>
    <Header/>
    <InstantSearch
      future={{
        preserveSharedStateOnUnmount: true
      }}
      indexName={ApiService.getDefaultIndex()}
      insights={true}
      routing={RouterService.getRouter()}
      searchClient={searchClient}>
      <Configure
        filters={ApiService.getContextFilters()}
        restrictSearchableAttributes={ApiService.getRestrictSearchableAttributes()}/>
      <InstantSearchContent/>
      <Listener/>
    </InstantSearch>
  </div>)
}

export default SearchApp
